import { render, staticRenderFns } from "./CustomersIndex.vue?vue&type=template&id=0d54d5cd&scoped=true&"
import script from "./CustomersIndex.vue?vue&type=script&lang=js&"
export * from "./CustomersIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomersIndex.vue?vue&type=style&index=0&id=0d54d5cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d54d5cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VDialog,VIcon,VProgressLinear,VTextField})
